<script setup>
import {ref} from "vue";
import TwoFactorSetupForm from "./TwoFactorSetupForm.vue";
import TwoFactorRecoveryCodesForm from "./TwoFactorRecoveryCodesForm.vue";

const props = defineProps({
  twoFactorAuthEnabled: {
    required: true,
    type: Boolean,
  },
  recoveryCodes: {
    required: false,
    type: Object,
    default: () => ({}),
  }
});

const showConfirmationView = ref(props.twoFactorAuthEnabled);
const recoveryCodes = ref(props.recoveryCodes);
const setupConfirmed = ref(false);

const handleSetupConfirmed = () => {
  showConfirmationView.value = true;
  setupConfirmed.value = true;
}
</script>

<template>
  <div class="row xs-mt-20">
    <div class="col-sm-12">
      <h2 class="text-dark xs-ml-5">
        Two-Factor Authentication
      </h2>
      <p class="letter-spacing xs-ml-5">
        Add additional security to your account using two-factor authentication.
      </p>
      <div class="card">
        <div class="card-block">
          <p class="letter-spacing mb-5">
            When two factor authentication is enabled, you will be prompted for a secure, random token during
            authentication. You may retrieve this token from your phone's Google Authenticator application.
          </p>
          <TwoFactorRecoveryCodesForm
            v-if="showConfirmationView"
            v-model:recoveryCodes="recoveryCodes"
            :show-recovery-codes="setupConfirmed"
            @disabled="showConfirmationView = false"
          />
          <TwoFactorSetupForm
            v-else
            v-model:recoveryCodes="recoveryCodes"
            @setup-confirmed="handleSetupConfirmed"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.letter-spacing {
  letter-spacing: 0.72px;
}
</style>
